module.exports = __webpack_public_path__ + "static/media/product_industrial_lcd.bdb3c8fd.jpg";